import classNames from "classnames";
import React from "react";
export default function Button(props) {
    var _a, _b, _c, _d, _e, _f;
    return (React.createElement("button", { className: classNames((_a = props.classNames) !== null && _a !== void 0 ? _a : "", {
            "button-disabled-extra-spacing": props.disableExtraSpacing,
            "align-left": props.align === "left",
            "align-center": props.align === "center",
            "align-right": props.align === "right",
        }), "data-version": (_b = props.version) !== null && _b !== void 0 ? _b : "classic", value: props.value, onClick: (_c = props.onClick) !== null && _c !== void 0 ? _c : (() => { }), onMouseDown: props.onClickStart, type: props.isSubmit ? "submit" : "button", "data-active": (_d = props.isActive) !== null && _d !== void 0 ? _d : false, ...((_e = props.extra) !== null && _e !== void 0 ? _e : {}) }, (_f = props.children) !== null && _f !== void 0 ? _f : props.text));
}
